import React from "react";
import "./listContent.css";
import { setChartTitle } from "../../redux/slices/uiSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export default function ListContent({ items, titleList }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setChartTitle(null));
  }, [dispatch]);

  if (!items || items.length === 0) {
    return <p className="list-empty">There are no items to show.</p>;
  }

  return (
    <div className="list-container">
      <h2 className="list-title">{titleList}</h2>
      <ul className="list-items">
        {items.map((item, index) => (
          <li key={index} className="list-item">
            <span className="list-index">{index + 1}.</span>
            <span className="list-text">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
